import { useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewDocument from 'modules/documents/components/Documents/New'
import { Folder } from 'modules/documents/hooks/useGetFolders'

const NewFolderDocumentPage = () => {
  const { navigation } = useNavigation()
  const { folder, employeeId, initialFolder } = useOutletContext<{
    employeeId: string
    folder: Folder
    initialFolder: Folder
  }>()

  return (
    <NewDocument
      employeeId={employeeId}
      folder={initialFolder}
      backRoute={navigation.documents.folderId.fullPath({ folderId: folder.id })}
    />
  )
}

export default NewFolderDocumentPage
